import { h, Component } from 'preact';
import Select, { components } from 'react-select';
import axios from 'axios';

const DropdownIndicator = (props) => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        <img
          className="select-list__dropdown"
          alt="Dropdown arrow"
          src="/public/images/icons/arrow-down.svg"
        />
      </components.DropdownIndicator>
    )
  );
};

class SiteSearch extends Component {
  state = {
    locations: [],
    inputValue: '',
    inputFocused: false,
    locationValue: 0,
    menuOpen: false,
    loading: true,
    searching: false,
    searched: false,
    searchResults: [],
    loadedClass: ''
  };

  async componentDidMount() {
    const searchQuery = this.getQueryString('q');
    await this.setState(() => ({
      loading: false,
      inputValue: searchQuery !== null ? decodeURI(searchQuery[1]) : ''
    }));
    if (searchQuery !== null) {
      this.performSearch();
    }
    setTimeout(() => {
      this.setState(() => ({
        loadedClass: 'js-loaded'
      }));
    }, 300);
  }

  getQueryString = (field) => {
    const href = window.location.href;
    const reg = new RegExp(`[?&]${field}=([^&#]*)`, 'i');
    const string = reg.exec(href);
    return string;
  };

  handleInputChange = (e) => {
    this.setState(() => ({
      inputValue: e.target.value
    }));
  };

  performSearch = async (e) => {
    e && e.preventDefault();
    this.setState(() => ({
      searching: true
    }));
    const { data: searchResults } = await axios.get(
      '/umbraco/api/sitesearch/dosearch',
      {
        params: {
          q: this.state.inputValue
        }
      }
    );
    let presearched = this.state.searched;
    this.setState(
      () => ({
        searched: true,
        searching: false,
        searchResults
      }),
      () => {
        if (presearched) {
          document.querySelector('.search__results').scrollIntoView({
            behavior: 'smooth'
          });
        }
      }
    );
  };

  render() {
    return (
      <div className={`search ${this.state.loadedClass}`}>
        
        <div aria-live="polite">
          {this.state.searched && (            
            <div className="search__results">
              <div className="search__results-wrapper">
                <h3 class="search__results-header">
                  We found {this.state.searchResults.length} result
                  {this.state.searchResults.length === 0 ||
                  this.state.searchResults.length > 1
                    ? 's'
                    : ''}
                </h3>
                {this.state.searchResults.length > 0 ? (
                  <ul className="vacancy-list">
                    {this.state.searchResults.map(
                      ({ Title, Url, TeaserText }) => (
                        <li className="vacancy-list__item vacancy-list__item--search">
                          <a href={Url} className="vacancy-list__link">
                            <h4 className="vacancy-list__title">{Title}</h4>
                            <span className="vacancy-list__detail vacancy-list__desc">
                                {TeaserText}
                            </span>
                            <button className="button button--blue-outline">
                              Find out more
                            </button>
                          </a>
                        </li>
                      )
                    )}
                  </ul>
                ) : (
                  <div className="search__no-results">
                    Your search returned no results.
                    <span className="search__no-results--small">
                      Please try again with a different search term.
                    </span>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const selectStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: '#5a5a7c',
    padding: '7px 5px 5px 5px',
    borderRadius: 0,
    border: '1px solid rgba(255, 255, 255, 0.2)',
    outline: state.isFocused ? 'none' : 'none',
    boxShadow: 'none !important'
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#ddd'
  }),
  option: (provided) => ({
    ...provided,
    opacity: 0.2
  }),
  singleValue: (provided) => ({
    ...provided,
    color: 'white'
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    display: 'none'
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: 'rgba(240, 240, 240, 0.2)',
    color: 'white',
    borderRadius: 0,
    marginTop: 0
  }),
  option: (provided, state) => ({
    ...provided,
    color: state.isSelected ? '#315185' : 'white',
    textAlign: 'left',
    backgroundColor: state.isSelected ? 'white' : 'transparent',
    '&:hover': {
      backgroundColor: state.isSelected ? 'white' : '#b7bfcb',
      color: state.isSelected ? '#232323' : 'white'
    }
  }),
  input: (provided) => ({
    ...provided,
    color: 'white'
  })
};

export default SiteSearch;
